<script lang="ts">
    import type { Page } from "../model";
    import { api } from "../stores";

    export let uid: string;
    export let index: number;
    export let side: string;

    let page: Page = null;
    let img = null;
    let imgWidth = 0;

    $: {
        $api.getPageByUid(uid).then((result) => {
            page = result;
        });
    }

    function refreshZones() {
        imgWidth = img.width;
    }
</script>

{#if page !== null}
    <div id="pageViewer">
        <div id="img_{index}" class="img" style="text-align: {side};">
            <img
                bind:this={img}
                on:load={refreshZones}
                src="{page.source}?g=3000x3000"
                id="page_{index}"
                alt="page_{index}"
            />
        </div>
    </div>
{/if}

<style lang="scss">
    @import "../styles/variables";

    #pageViewer {
        height: 100%;
        position: relative;
        display: flex;
        // flex-direction: column;
        justify-content: center;
    }

    .img {
        //border: blue solid 1px;
        max-height: 100%;
        max-width: 100%;
        position: relative;
        height: 100%;
        width: auto;
        // display: flex;
        float: left;
        overflow: hidden;
        // justify-content: center;
        img {
            // object-fit: cover;
            width: auto;
            max-height: 100%;
            // position: absolute;
            // top: 0;
            // left: 0;

            -webkit-tap-highlight-color: transparent;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            &:focus {
                outline: none !important;
            }
        }
    }

    @media (max-width: $mobile-breakpoint) {
        #pageViewer {
            width: 100%;
        }
        // .zones {
        //   .detail {
        //     opacity: 1!important;
        //     background-color: $grey-darken!important;
        //   }
        // }
    }

    @media (max-width: $large-screen-breakpoint) {
        #pageViewer {
            .img {
                text-align: center !important;
                // .zones-area {
                //   top: 50%;
                //   left: 50%;
                //   transform: translate(-50%, -50%);
                // }
            }
        }
    }
</style>
